<template>
    <div class="row">
        <div class="col-12">
        </div>
        <div class="col-12">
            <h1>{{ zona.sector }}</h1>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['zona', 'zonas'],
        data() {
            return {
                loading: true,
                new_zona: null
            }
        },
        watch: {
            new_zona() {
                if(this.new_zona != null) {
                    this.$emit('changeZona', this.new_zona);
                    this.new_zona = null;
                }                
            }
        },
    }
</script>
